import "../../../../src/styles/developer-resource.css";
import ExtractStepperComponent from "../../../../src/pages/apis/pdf-extract/extract-stepper.md";
import WhyExtractAPI from "../../../../src/pages/apis/pdf-extract/why-extract-api.md";
import ExtractProductCard from "../../../../src/pages/apis/pdf-extract/extract-product.md";
import VisualizerHowItWorks from "../../../../src/pages/apis/pdf-extract/visualizer-how-it-works.md";
import { VisualizerCustomIframeBlock } from "../../../../src/components/visualizerCustomIframe";
import EsealApiAnnouncement from "../../../../src/pages/apis/e-seal-api-announcement.md";
import * as React from 'react';
export default {
  ExtractStepperComponent,
  WhyExtractAPI,
  ExtractProductCard,
  VisualizerHowItWorks,
  VisualizerCustomIframeBlock,
  EsealApiAnnouncement,
  React
};